import {
  useSharedState,
  useSharedStateDispatch,
} from "../contexts/SharedStateContext";

// Custom hook for currentStep management
export const useCurrentStep = () => {
  const state = useSharedState();
  const dispatch = useSharedStateDispatch();

  const currentStep = state.currentStep || 0;

  const setCurrentStep = (step: number | ((prev: number) => number)) => {
    const newStep = typeof step === "function" ? step(currentStep) : step;
    dispatch({ type: "SET_CURRENT_STEP", step: newStep });
  };

  return { currentStep, setCurrentStep };
};
